/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Tanksanitaryhotwatertemperature4Inputs */



/**
* | output |
* | --- |
* | "Domestic hot water tank temperature" |
*
* @param {Br_History_Key_Tanksanitaryhotwatertemperature4Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_tanksanitaryhotwatertemperature4 = /** @type {((inputs?: Br_History_Key_Tanksanitaryhotwatertemperature4Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Tanksanitaryhotwatertemperature4Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Domestic hot water tank temperature")
	return /** @type {LocalizedString} */ ("Température du ballon")
});
export { br_history_key_tanksanitaryhotwatertemperature4 as "br_history_key_tankSanitaryHotWaterTemperature" }